module.exports = __webpack_public_path__ + "img/m-arrow-left-grey-default.ebba3d94.svg";